/* @flow */

const locationRoutes = {
  locations: 'locations',
  countries: 'companies/:companyId',
  countryLocations: 'companies/:companyId/country-locations/:countryId',
  company: 'companies',
  companyUsersPerRole: 'companies/:companyId/user-role/:role',
  countryUsersPerRole: 'companies/:companyId/user-role/:role/countries/:countryId',
  locationUsersPerRole: 'locations/:locationId/user-role/:role',
  companyCountryDetails: 'companies/:companyId/countries/:countryId',
  locationDetails: 'locations/:locationId',
  locationWorkspaces: 'locations/:locationId/workspaces/:siteId',
  activity: 'locations/:locationId/activity',
  byCompanyAndCountry: 'locations/:companyId/:countryId',
};

export default locationRoutes;
